import { Modal } from '@/components/Modal'
import { PrimaryButton, SecondaryButton } from '@/components/Button'

interface ConfirmDialogProps {
  open: boolean
  title: string
  description: string
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onCancel}
      footer={
        <>
          <SecondaryButton onClick={onCancel}>{cancelLabel}</SecondaryButton>
          <PrimaryButton className={danger ? 'button--danger' : ''} onClick={onConfirm}>
            {confirmLabel}
          </PrimaryButton>
        </>
      }
    >
      <p>{description}</p>
    </Modal>
  )
}
